import React, { useState, useEffect } from "react";
import { Image } from 'react-bootstrap';
import Slider from "react-slick";
import TextLink from "../Text/TextLink";
import MainStyles from "../../styles/MainStyles";
import ArrowIcon from '../../assets/images/chevron-down.svg'
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import './index.css'

let sliderContainer = null

window.matchMedia = window.matchMedia || function() {
  return {
      matches : false,
      addListener : function() {},
      removeListener: function() {}
  };
};

const Arrow = (props) => {
  const { className, style, isPrev, onClick } = props;
  const prevArrow = {...style, transform: 'rotate(-180deg)', top: '30px' }
  const nextArrow = {...style, top: '45px' }
  return (
    <Image 
      className={`${className} garage-arrow`}
      src={ArrowIcon}
      style={isPrev ? prevArrow : nextArrow}
      onClick={onClick}
    />
  );
}

const GarageList = ({vehicleModels, selectModel, selectedModel}) => {
  const [selectedIndex, setIndex] = useState(null)

  useEffect(() => {
    if(selectedModel) {
      vehicleModels.forEach((filtered, index) => {
        if(selectedModel.modelDetails && filtered.vin === selectedModel.modelDetails.vin) {
          if(sliderContainer && selectedIndex !== index) {
            sliderContainer.slickGoTo(index)
            setIndex(index)
          }
        }
      })
    }
  })

  const settings = {
    dots: false,
    infinite: vehicleModels.length > 3 ? true : false,
    centerMode: true,
    focusOnSelect: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <Arrow />,
    prevArrow: <Arrow isPrev />,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 544,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ],
    afterChange: index => {
      let selectedItem = vehicleModels.find((item, itemInde) => itemInde === index)
      //selected new model -> avoid to selected 2 times same model
      if(selectedItem && selectedItem.vin && selectedItem.vin !== selectedModel.modelDetails.vin) {
        selectModel(selectedItem.vin)
      }
    }
  };
  return (
    <Slider ref={slider => (sliderContainer = slider)} className='garage-slide' {...settings}>
      { vehicleModels.map((mapped, index) => (
        <TextLink
          key={`link-model-${index}`}
          text={mapped.modelName}
          color={MainStyles.colors.white}
          size={'medium'}
          onClick={() => {
            setIndex(index)
            selectModel(mapped.vin)
          }}
        />
      ))}
    </Slider>
  );
}

export default GarageList